"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
class EventEmitter {
    constructor() {
        this.callbacks = {};
    }
    on(event, callback) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(callback);
    }
    off(event, callback) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            const index = callbacks.indexOf(callback);
            if (index > -1) {
                callbacks.splice(index, 1);
            }
        }
    }
    emit(event, ...data) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            return callbacks.map(cb => cb(...data));
        }
        return [];
    }
}
exports.EventEmitter = EventEmitter;
